import { SupportedLanguage } from '../../enums/supportedLanguage';

const LANGUAGE_LABEL_EN_US = 'account.preferences.languages.enUS';
const LANGUAGE_LABEL_EN_GB = 'account.preferences.languages.enGB';
const LANGUAGE_LABEL_PT_BR = 'account.preferences.languages.ptBR';

export const languages = [
  { id: '1', label: LANGUAGE_LABEL_EN_US, value: SupportedLanguage.EN_US },
  { id: '2', label: LANGUAGE_LABEL_EN_GB, value: SupportedLanguage.EN_GB },
  { id: '3', label: LANGUAGE_LABEL_PT_BR, value: SupportedLanguage.PT_BR },
];

const PORTUGUESE_LANGUAGE_PREFIX = 'pt';

export function resolveSupportedLanguage(
  raw: string | undefined | null,
): string {
  if (!raw) {
    return SupportedLanguage.EN_US;
  }

  const normalized = raw.toLowerCase();

  if (normalized.startsWith(PORTUGUESE_LANGUAGE_PREFIX)) {
    return SupportedLanguage.PT_BR;
  }

  if (normalized === SupportedLanguage.EN_GB.toLowerCase()) {
    return SupportedLanguage.EN_GB;
  }

  return SupportedLanguage.EN_US;
}
